import script from "./RecordButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordButton.vue?vue&type=script&setup=true&lang=ts"

import "./RecordButton.vue?vue&type=style&index=0&id=08466581&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08466581"]])

export default __exports__